module.exports = new __parcel__URL__("WordleBotPortfolioPiece.a81ee3d3.svg").toString();